import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import useDefaultRoutePath from "src/app/Restricted/useDefaultRoutePath";

type HomeLinkProps = {
  children?: ReactNode;
  item: { name?: string };
  className?: string;
};

const HomeLink = ({ children, item, className }: HomeLinkProps) => {
  const defaultRoutePath = useDefaultRoutePath();
  return (
    <Link to={defaultRoutePath} aria-label={item.name} className={className}>
      {children}
    </Link>
  );
};

export default HomeLink;
